"use client";

import { ClerkProvider as BaseClerkProvider } from "@clerk/nextjs";
import type { ReactNode } from "react";

interface ClerkProviderProps {
  children: ReactNode;
  /** Override the default publishable key from env */
  publishableKey?: string;
}

/**
 * Wraps Clerk's ClerkProvider with defaults pulled from env vars.
 * Use this at the root layout of your Next.js app.
 *
 * Required env: NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY
 */
export function ClerkProvider({
  children,
  publishableKey,
}: ClerkProviderProps) {
  const key = publishableKey ?? process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY;

  if (!key) {
    // Allow builds/SSG without Clerk credentials
    return <>{children}</>;
  }

  return (
    <BaseClerkProvider publishableKey={key} afterSignOutUrl="/">
      {children}
    </BaseClerkProvider>
  );
}
